import {GSHEET_URL} from '../../constants';

const ALPHABET_U = Array.from(Array(26)).map((e, i) => i + 65);
// const ALPHABET_L = Array.from(Array(26)).map((e, i) => i + 97);
const ALPHABET = ALPHABET_U.map((x) => String.fromCharCode(x));

const COLUMN_NAMES = ALPHABET.concat(ALPHABET.map((i) => {
  return 'A' + i;
}));

export function getIndexName(index) {
  return COLUMN_NAMES[index];
}

export function getColumnIndex(table_header, header_name) {
  return table_header.indexOf(header_name);
}

export function getColumnIndexName(table_header, header_name) {
  const index = getColumnIndex(table_header, header_name);
  return getIndexName(index);
}

export async function readGsheet(spreadsheet_id, sheet_name) {
  // let resp = await window.gapi.client.sheets.spreadsheets.values.get({
  //   spreadsheetId: spreadsheet_id,
  //   range: 'Sheet1',
  // });
  // return resp.result.values;

  const url = `${GSHEET_URL}?spreadsheet_id=${spreadsheet_id}&sheet=${sheet_name}`;
  const request = new Request(
    url,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
    }
  );
  const resp = await fetch(request);
  return await resp.json();
}

const STRING_FORMAT = [
  'Patient Alias',
  'Accession',
  'Isolate Name',
];

// const delay = ms => new Promise(
//   resolve => setTimeout(resolve, ms)
// );

// const AUTO_RESIZE_COLUMN = {
//   "autoResizeDimensions": {
//     "dimensions": {
//       "sheetId": 0,
//       "dimension": "COLUMNS",
//     }
//   }
// };

// const FREEZE_HEADER = {
//   "updateSheetProperties": {
//     "properties": {
//       "sheetId": 0,
//       "gridProperties": {
//         "frozenRowCount": 1
//       }
//     },
//     "fields": "gridProperties.frozenRowCount"
//   }
// };

// export async function createFolder(title) {
//   try {
//     let resp = await window.gapi.client.drive.files.list({
//       q: "name = '" + title + "'",
//       fields: 'files(id, name)'
//     });
//     if (resp.result.files.length > 0) {
//       return resp.result.files[0].id;
//     }

//     resp = await window.gapi.client.drive.files.create({
//       name: 'mangabey',
//       mimeType: 'application/vnd.google-apps.folder',
//       fields: 'id'
//     });

//     return resp.result.id;
//   } catch (resp) {
//     if (resp.result.error && resp.result.error.message === 'Invalid Credentials') {
//       window.reAuth();
//     }
//   }
// }

export async function createGsheet(spreadsheet_id, title, sheet, rows, formats=[]) {
  // if (!window.gapi.client || !window.gapi.client.sheets || !window.gapi.client.sheets.spreadsheets){
  //   await delay(2000);
  // }

  // let folder_id = await createFolder('Mangabey');

  // let spreadsheet_id = null;
  // try {
  //   let response = await window.gapi.client.sheets.spreadsheets.create({
  //     properties: {
  //       title: title,
  //     },
  //   });
  //   spreadsheet_id = response.result.spreadsheetId;
  //   // console.log('Spreadsheet ID: ' + response.result.spreadsheetId);

  //   response = await window.gapi.client.drive.files.get({
  //     fileId: spreadsheet_id,
  //     fields: 'parents'
  //   });

  //   response = await window.gapi.client.drive.files.update({
  //     fileId: spreadsheet_id,
  //     addParents: folder_id,
  //     removeParents: response.result.parents,
  //     fiels: 'id, parents'
  //   });
  // } catch (err) {
  //   // document.getElementById('content').innerText = err.message;
  //   // eslint-disable-next-line no-console
  //   console.log(err);
  //   if (err.result.error.status === 'UNAUTHENTICATED') {
  //     window.reAuth();
  //     // window.location.reload();
  //   }
  //   return null;
  // }

  // const headers = rows[0];
  // for (const header of headers) {
  //   if (STRING_FORMAT.includes(header)) {
  //     const column = STRING_FORMAT.indexOf(header);
  //     rows = rows.map((row) => {
  //       let value = row[column];
  //       value = value ? `${value}`: '';
  //       value = (!value.startsWith("'"))? `'${value}`: value;
  //       row[column] = value;
  //       row.push('');
  //       return row;
  //     });
  //   }
  // }

  // let params = {
  //   spreadsheetId: spreadsheet_id,
  //   range: 'Sheet1',
  //   valueInputOption: 'USER_ENTERED'
  // };

  // let valueRangebody = {
  //   range: 'Sheet1',
  //   values: rows
  // };

  // await window.gapi.client.sheets.spreadsheets.values.update(params, valueRangebody);

  // await updateSheet(spreadsheet_id, formats);

  // return spreadsheet_id;

  if (rows.length !== 0) {
    const headers = rows[0];

    for (const header of headers) {
      if (STRING_FORMAT.includes(header)) {
        const column = STRING_FORMAT.indexOf(header);
        rows = rows.map((row) => {
          let value = row[column];
          value = value ? `${value}`: '';
          value = (!value.startsWith("'"))? `'${value}`: value;
          row[column] = value;
          row.push('');
          return row;
        });
      }
    }
  }

  const request = new Request(
    GSHEET_URL,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        'spreadsheet_id': spreadsheet_id,
        'title': title,
        'rows': rows,
        'formats': formats,
        'sheet': sheet,
      })
    }
  );
  const resp = await fetch(request);
  const json = await resp.json();

  return json;
}

export async function updateSheet(spreadsheet_id, sheet_name, formats=[]) {
  // let format_req = [
  //   AUTO_RESIZE_COLUMN,
  //   FREEZE_HEADER,
  // ];
  // format_req = format_req.concat(formats);

  // await window.gapi.client.sheets.spreadsheets.batchUpdate({
  //   spreadsheetId: spreadsheet_id
  // }, {
  //   requests: format_req
  // });
  // return spreadsheet_id;
  const url = `${GSHEET_URL}?spreadsheet_id=${spreadsheet_id}`;
  const request = new Request(
    url,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        'formats': formats,
        'sheet': sheet_name
      })
    }
  );
  const resp = await fetch(request);
  const json = await resp.json();
  return json.spreadsheet_id;
}

export async function deleteGsheet(spreadsheet_id) {
  // await window.gapi.client.drive.files.delete({
  //   fileId: spreadsheet_id
  // });
  const url = `${GSHEET_URL}?spreadsheet_id=${spreadsheet_id}`;
  const request = new Request(
    url,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }
  );
  const resp = await fetch(request);
  return await resp.json();
}

export function getGsheetURL(spreadsheet_id) {
  const url = `https://docs.google.com/spreadsheets/d/${spreadsheet_id}/edit`;
  return url;
}

export function openGsheet(spreadsheet_id) {
  const url = `https://docs.google.com/spreadsheets/d/${spreadsheet_id}/edit`;
  const new_window = window.open();
  new_window.location.href = url;
}

export function getColumnConditionalFormat(column_index, condition, color) {

  const sheetId = 0;
  const start_column = column_index;
  const end_column = column_index + 1;

  const format = {
    "addConditionalFormatRule": {
      "rule": {
        "ranges": [
          {
            "sheetId": sheetId,
            "startColumnIndex": start_column,
            "endColumnIndex": end_column,
          },
        ],
        "booleanRule": {
          "condition": condition,
          "format": color,
        }
      },
      "index": 0,
    }
  };

  return format;
}

export async function readColumn(spreadsheet_id, sheet_name, column_index_name) {
  // let data = await readGsheet(spreadsheet_id);
  // let row_length = data.length;

  // data = await window.gapi.client.sheets.spreadsheets.values.get({
  //   spreadsheetId: spreadsheet_id,
  //   range: `Sheet1!${column_index_name}2:${column_index_name}${row_length}`,
  //   majorDimension: 'COLUMNS',
  //   valueRenderOption: 'UNFORMATTED_VALUE'
  // });

  // return data.result.values;
  const url = (
    `${GSHEET_URL}/column?` +
    `spreadsheet_id=${spreadsheet_id}` +
    `&sheet=${sheet_name}` +
    `&column=${column_index_name}`
  );
  const request = new Request(
    url,
    {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

    }
  );
  const resp = await fetch(request);
  const json = await resp.json();
  return json;
}

export async function updateColumn(
  spreadsheet_id, sheet_name, column_index_name, value) {

  // let data = await readGsheet(spreadsheet_id);
  // let row_length = data.length;
  // let rec_length = data.length - 1;
  // let range = `Sheet1!${column_index_name}2:${column_index_name}${row_length}`;

  // await window.gapi.client.sheets.spreadsheets.values.update({
  //   spreadsheetId: spreadsheet_id,
  //   range: range,
  //   valueInputOption: 'USER_ENTERED',
  // }, {
  //   range: range,
  //   majorDimension: 'COLUMNS',
  //   values: [
  //     Array(rec_length).fill(value)
  //   ]
  // });
  const request = new Request(
    `${GSHEET_URL}/column`,
    {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        'spreadsheet_id': spreadsheet_id,
        'sheet': sheet_name,
        'column': column_index_name,
        'value': value,
        'method': 'by_value',
      })
    }
  );
  const resp = await fetch(request);
  const json = await resp.json();
  return json;
}

export async function updateColumnByColumn(
  spreadsheet_id, sheet_name, column_index_name, by_column_index_name) {

  // if (column_index_name == by_column_index_name) {
  //   return;
  // }

  // let data = await readColumn(spreadsheet_id, by_column_index_name);
  // if (!data) {
  //   return;
  // }
  // let row_length = data[0].length + 1;
  // let range = `Sheet1!${column_index_name}2:${column_index_name}${row_length}`;

  // let values = data[0].map((i) => {
  //   return [i ? (String(i).startsWith("'") ? `${i}`: `'${i}`): ''];
  // });

  // await window.gapi.client.sheets.spreadsheets.values.update({
  //   spreadsheetId: spreadsheet_id,
  //   range: range,
  //   valueInputOption: 'USER_ENTERED',
  // }, {
  //   range: range,
  //   // majorDimension: 'COLUMNS',
  //   values: values
  // });

  const request = new Request(
    `${GSHEET_URL}/column`,
    {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        'spreadsheet_id': spreadsheet_id,
        'sheet': sheet_name,
        'column': column_index_name,
        'by_column': by_column_index_name,
        'method': 'by_column',
      })
    }
  );
  const resp = await fetch(request);
  const json = await resp.json();
  return json;
}


export async function addColumn(spreadsheet_id, sheet_name, value) {
  // let data = await readGsheet(spreadsheet_id);
  // let first_row = data[0];
  // let column_index = first_row.length;

  // if (first_row.indexOf(value) > -1) {
  //   return;
  // }

  // if (column_index > COLUMN_NAMES.length) {
  //   // console.log('too many columns');
  //   return;
  // }

  // let column = COLUMN_NAMES[column_index];

  // let range = `Sheet1!${column}1:${column}1`;

  // return await window.gapi.client.sheets.spreadsheets.values.update({
  //   spreadsheetId: spreadsheet_id,
  //   range: range,
  //   valueInputOption: 'USER_ENTERED'
  // }, {
  //   range: range,
  //   majorDimension: 'COLUMNS',
  //   values: [[value]]
  // });

  const request = new Request(
    `${GSHEET_URL}/column`,
    {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        'spreadsheet_id': spreadsheet_id,
        'sheet': sheet_name,
        'column': 'A',
        'value': value,
        'method': 'add_column',
      })
    }
  );
  const resp = await fetch(request);
  const json = await resp.json();
  return json;
}



// WEBPACK FOOTER //
// ./src/components/gsheet/index.js